import { ReactNode } from 'react';

export interface IChildren {
  children: string | ReactNode;
}

/**
 *------------------------------------------------------------------------------
 * It renders an avatar with the provided children.
 * @deprecated - Delete this as it's too old and obsolete
 */
export function AvatarV1({ children }: IChildren) {
  return (
    <div
      className="
        to-grey-700 align-center flex w-fit justify-center rounded-full
        bg-gradient-to-b from-green-700 from-40% to-gray-400
      "
    >
      <div
        className="
          m-0.5 grid aspect-square w-fit place-content-center
          rounded-full bg-gray-50/90
        "
      >
        <div
          className="
            aspect-square w-fit rounded-full bg-gradient-to-b from-green-600
            from-50% to-gray-800 to-70% bg-clip-text p-3 text-center
            text-base font-semibold text-transparent
          "
        >
          {children}
        </div>
      </div>
    </div>
  );
}
